import React from "react"

import { SliderProps } from "@mui/material/Slider/Slider"

import { StyledSlider } from "./styled"

export const Slider = (props: SliderProps) =>
  <StyledSlider
    color="primary"
    onKeyDown={(event) => {
      if (event.ctrlKey) event.preventDefault()
    }}
    {...props} />
